import { UserType } from '../user'

export enum AuthFlowType {
  Login = 'signin',
  Join = 'signup',
  Logout = 'signout',
}

export interface IAuthState {
  type?: UserType
  mode: AuthFlowType
}

export const getJoinMode = (type?: UserType): IAuthState => {
  return {
    ...(!!type ? { type } : {}),
    mode: AuthFlowType.Join,
  }
}

export const getDirectorJoinMode = (): IAuthState => {
  return {
    type: UserType.Director,
    mode: AuthFlowType.Join,
  }
}
export const getParentJoinMode = (): IAuthState => {
  return {
    type: UserType.Parent,
    mode: AuthFlowType.Join,
  }
}
export const getLoginMode = (userType?: UserType): IAuthState => {
  return {
    ...(!!userType ? { type: userType } : {}),
    mode: AuthFlowType.Login,
  }
}
export const getLogoutMode = (): IAuthState => {
  return {
    mode: AuthFlowType.Logout,
  }
}
